import React, { useState } from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import ModalForm from "../components/Common/ModalForm"
import { Row, Col } from "react-bootstrap"
import Image from "gatsby-image"
import Layout from "../components/Common/Layout"
import { saveLead, checkEmail, saveSeed } from "../utils/emails"
import Parser from "html-react-parser"
import Spinner from "../images/meets/Spinner.gif"

import RowSpeakerOne from "../components/CleverMeets/SpeakersRowOne"
import RowSpeakerTwo from "../components/CleverMeets/SpeakersRowTwo"
import RowSpeakerSix from "../components/CleverMeets/SpeakersRowSix"
import SpeakerRowThreeTwo from "../components/CleverMeets/SpeakerRowThreeTwo"
import OtherSection from "../components/CleverMeets/OtherSection"
import LogoSection from "../components/CleverMeets/LogoSection"
import ShowDonate from "../components/CleverMeets/ShowDonate"
import LogoClevermeets from "../components/CleverMeets/LogoClevermeets"
import ImgPortada from "../components/CleverMeets/ImgPortada"
import ShowInscription from "../components/CleverMeets/ShowInscription"

export const query = graphql`
  query($slug: String!) {
    eventsJson(slug: { eq: $slug }) {
      id
      templateId
      text
      subText
      video
      date

      speakerTitle
      slug
      nameSpeakerOne
      jobSpeakerOne
      companySpeakerOne
      linkedinLinkSpeakerOne

      nameSpeakerTwo
      jobSpeakerTwo
      companySpeakerTwo
      linkedinLinkSpeakerTwo

      nameSpeakerThree
      jobSpeakerThree
      companySpeakerThree
      linkedinLinkSpeakerThree

      nameSpeakerFour
      jobSpeakerFour
      companySpeakerFour
      linkedinLinkSpeakerFour

      nameSpeakerFive
      jobSpeakerFive
      companySpeakerFive
      linkedinLinkSpeakerFive

      nameSpeakerSix
      jobSpeakerSix
      companySpeakerSix
      linkedinLinkSpeakerSix

      altLogoClever
      altCompanyOne
      showInput

      titleModerator
      support

      titleSection
      contentSection
      contentSectionTwo
      colorSection

      time
      backColor
      colorInput
      colorSpeaker
      textColor
      layout
      clientId
      widthContainer
      layountPage
      disclaimer
      webinar
      colorTextSpeaker
      btnInputColor
      btnBorder
      btnBorderRadius
      btnInputColorDown
      btnInputColorText
      paddingSpeaker
      anim

      logoMeets {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      imgPortada {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      imgTime {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      speakerOne {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      speakerTwo {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      speakerThree {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      speakerFour {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      speakerFive {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      speakerSix {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      linkedinIcon {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logoClever {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      imgSectionOne {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      imgSectionTwo {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      logoCompanyOne {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`
const EventPage = ({ data }) => {
  const event = data.eventsJson

  const { id, templateId, text } = event

  const [toVideo, setToVideo] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [email, setEmail] = useState()
  const [loading, setLoading] = useState(true)
  const [disabledButton, setDisabledButton] = useState(false)

  const handleSuccess = () => {
    saveLeads(email)
    setToVideo(true)
    console.log("funcionaaaaa")
  }
  // const handleSuccessSendEmail = () => {
  //   setSubmitted(true)
  // }

  const showInput = event.showInput
  const backColor = event.backColor
  const timeText = event.time
  const layout = event.layout
  const textColor = event.textColor
  const slugName = event.slug
  const clientId = event.clientId
  const idMailing = event.id
  const templateIdMailing = event.templateId
  const textMailing = event.text
  const widthContainer = event.widthContainer
  const colorInput = event.colorInput
  const colorSpeaker = event.colorSpeaker
  const titleModerator = event.titleModerator
  /* const logoClever = event.logoClever.childImageSharp.fluid */

  const saveLeads = async email => {
    setLoading(false)
    if (checkEmail(email)) {
      await saveLead(email, id, templateId, text, email)

      setLoading(false)
      setSubmitted(true)
    }
  }
  const saveSeeds = async email => {
    setLoading(false)
    if (checkEmail(email)) {
      await saveSeed(email)

      setLoading(false)
      setToVideo(true)
      setSubmitted(true)
    }
  }

  return (
    <>
      <div style={{ backgroundColor: backColor }}>
        <Layout location="clevermeets">
          <ModalForm />
          <EventContainer
            style={{
              color: textColor,
              width: ` ${widthContainer} `,
            }}
          >
            {event.layountPage === "one" && (
              <>
                <DivLogo>
                  <LogoClevermeets
                    fluidImg={event.logoMeets.childImageSharp.fluid}
                    alt={event.text}
                  ></LogoClevermeets>
                </DivLogo>

                <Title>{Parser(event.text)}</Title>

                <SubTitle>{Parser(event.subText)}</SubTitle>

                <RowImg className="row">
                  {/*  <img src={portada} alt="icon agile"></img> */}
                  <Col xl={5}>
                    <Image
                      fluid={event.imgPortada.childImageSharp.fluid}
                      alt={event.text}
                    ></Image>
                  </Col>
                </RowImg>
              </>
            )}

            {event.layountPage === "two" && (
              <>
                <ImgPortada
                  fluidImgLogo={event.logoMeets.childImageSharp.fluid}
                  altLogo={event.text}
                  fluid={event.imgPortada.childImageSharp.fluid}
                  alt={event.text}
                  title={event.text}
                  subTitle={event.subText}
                  logoClever={event.logoClever.childImageSharp.fluid}
                  logoCompanyOne={event.logoCompanyOne.childImageSharp.fluid}
                  altCompanyOne={event.altCompanyOne}
                  date={event.date}
                  linkVideo={event.video}
                  idMail={event.id}
                  templateId={event.templateId}
                  text={event.text}
                  colorInput={event.colorInput}
                  anim={event.anim}
                  webinar={event.webinar}
                  colorSpeaker={event.colorSpeaker}
                  btnInputColor={event.btnInputColor}
                  btnBorder={event.btnBorder}
                  btnBorderRadius={event.btnBorderRadius}
                ></ImgPortada>
              </>
            )}
            {layout === "onerow" && (
              <RowSpeakerOne
                fluidSpeakerOne={event.speakerOne.childImageSharp.fluid}
                nameSpeakerOne={event.nameSpeakerOne}
                jobSpeakerOne={event.jobSpeakerOne}
                companySpeakerOne={event.companySpeakerOne}
                linkSpeakerOne={event.linkedinLinkSpeakerOne}
                LinkIcon={event.linkedinIcon.childImageSharp.fluid}
                fluidSpeakerTwo={event.speakerTwo.childImageSharp.fluid}
                nameSpeakerTwo={event.nameSpeakerTwo}
                jobSpeakerTwo={event.jobSpeakerTwo}
                companySpeakerTwo={event.companySpeakerTwo}
                linkSpeakerTwo={event.linkedinLinkSpeakerTwo}
                fluidSpeakerThree={event.speakerThree.childImageSharp.fluid}
                nameSpeakerThree={event.nameSpeakerThree}
                jobSpeakerThree={event.jobSpeakerThree}
                companySpeakerThree={event.companySpeakerThree}
                linkSpeakerThree={event.linkedinLinkSpeakerThree}
                fluidSpeakerFour={event.speakerFour.childImageSharp.fluid}
                nameSpeakerFour={event.nameSpeakerFour}
                jobSpeakerFour={event.jobSpeakerFour}
                companySpeakerFour={event.companySpeakerFour}
                linkSpeakerFour={event.linkedinLinkSpeakerFour}
                fluidSpeakerFive={event.speakerFive.childImageSharp.fluid}
                nameSpeakerFive={event.nameSpeakerFive}
                jobSpeakerFive={event.jobSpeakerFive}
                companySpeakerFive={event.companySpeakerFive}
                linkSpeakerFive={event.linkedinLinkSpeakerFive}
                fluidSpeakerSix={event.speakerSix.childImageSharp.fluid}
                nameSpeakerSix={event.nameSpeakerSix}
                jobSpeakerSix={event.jobSpeakerSix}
                companySpeakerSix={event.companySpeakerSix}
                linkSpeakerSix={event.linkedinLinkSpeakerSix}
                colorSpeaker={colorSpeaker}
                titleModerator={titleModerator}
              ></RowSpeakerOne>
            )}
            {layout === "tworows" && (
              <RowSpeakerTwo
                fluidSpeakerOne={event.speakerOne.childImageSharp.fluid}
                nameSpeakerOne={event.nameSpeakerOne}
                jobSpeakerOne={event.jobSpeakerOne}
                companySpeakerOne={event.companySpeakerOne}
                linkSpeakerOne={event.linkedinLinkSpeakerOne}
                LinkIcon={event.linkedinIcon.childImageSharp.fluid}
                fluidSpeakerTwo={event.speakerTwo.childImageSharp.fluid}
                nameSpeakerTwo={event.nameSpeakerTwo}
                jobSpeakerTwo={event.jobSpeakerTwo}
                companySpeakerTwo={event.companySpeakerTwo}
                linkSpeakerTwo={event.linkedinLinkSpeakerTwo}
                fluidSpeakerThree={event.speakerThree.childImageSharp.fluid}
                nameSpeakerThree={event.nameSpeakerThree}
                jobSpeakerThree={event.jobSpeakerThree}
                companySpeakerThree={event.companySpeakerThree}
                linkSpeakerThree={event.linkedinLinkSpeakerThree}
                fluidSpeakerFour={event.speakerFour.childImageSharp.fluid}
                nameSpeakerFour={event.nameSpeakerFour}
                jobSpeakerFour={event.jobSpeakerFour}
                companySpeakerFour={event.companySpeakerFour}
                linkSpeakerFour={event.linkedinLinkSpeakerFour}
                fluidSpeakerFive={event.speakerFive.childImageSharp.fluid}
                nameSpeakerFive={event.nameSpeakerFive}
                jobSpeakerFive={event.jobSpeakerFive}
                companySpeakerFive={event.companySpeakerFive}
                linkSpeakerFive={event.linkedinLinkSpeakerFive}
                fluidSpeakerSix={event.speakerSix.childImageSharp.fluid}
                nameSpeakerSix={event.nameSpeakerSix}
                jobSpeakerSix={event.jobSpeakerSix}
                companySpeakerSix={event.companySpeakerSix}
                linkSpeakerSix={event.linkedinLinkSpeakerSix}
              ></RowSpeakerTwo>
            )}
            {layout === "sixrows" && (
              <RowSpeakerSix
                fluidSpeakerOne={event.speakerOne.childImageSharp.fluid}
                nameSpeakerOne={event.nameSpeakerOne}
                jobSpeakerOne={event.jobSpeakerOne}
                companySpeakerOne={event.companySpeakerOne}
                linkSpeakerOne={event.linkedinLinkSpeakerOne}
                LinkIcon={event.linkedinIcon.childImageSharp.fluid}
                fluidSpeakerTwo={event.speakerTwo.childImageSharp.fluid}
                nameSpeakerTwo={event.nameSpeakerTwo}
                jobSpeakerTwo={event.jobSpeakerTwo}
                companySpeakerTwo={event.companySpeakerTwo}
                linkSpeakerTwo={event.linkedinLinkSpeakerTwo}
                fluidSpeakerThree={event.speakerThree.childImageSharp.fluid}
                nameSpeakerThree={event.nameSpeakerThree}
                jobSpeakerThree={event.jobSpeakerThree}
                companySpeakerThree={event.companySpeakerThree}
                linkSpeakerThree={event.linkedinLinkSpeakerThree}
                fluidSpeakerFour={event.speakerFour.childImageSharp.fluid}
                nameSpeakerFour={event.nameSpeakerFour}
                jobSpeakerFour={event.jobSpeakerFour}
                companySpeakerFour={event.companySpeakerFour}
                linkSpeakerFour={event.linkedinLinkSpeakerFour}
                fluidSpeakerFive={event.speakerFive.childImageSharp.fluid}
                nameSpeakerFive={event.nameSpeakerFive}
                jobSpeakerFive={event.jobSpeakerFive}
                companySpeakerFive={event.companySpeakerFive}
                linkSpeakerFive={event.linkedinLinkSpeakerFive}
                fluidSpeakerSix={event.speakerSix.childImageSharp.fluid}
                nameSpeakerSix={event.nameSpeakerSix}
                jobSpeakerSix={event.jobSpeakerSix}
                companySpeakerSix={event.companySpeakerSix}
                linkSpeakerSix={event.linkedinLinkSpeakerSix}
              ></RowSpeakerSix>
            )}
            {layout === "threetworow" && (
              <SpeakerRowThreeTwo
                fluidSpeakerOne={event.speakerOne.childImageSharp.fluid}
                nameSpeakerOne={event.nameSpeakerOne}
                jobSpeakerOne={event.jobSpeakerOne}
                companySpeakerOne={event.companySpeakerOne}
                linkSpeakerOne={event.linkedinLinkSpeakerOne}
                LinkIcon={event.linkedinIcon.childImageSharp.fluid}
                fluidSpeakerTwo={event.speakerTwo.childImageSharp.fluid}
                nameSpeakerTwo={event.nameSpeakerTwo}
                jobSpeakerTwo={event.jobSpeakerTwo}
                companySpeakerTwo={event.companySpeakerTwo}
                linkSpeakerTwo={event.linkedinLinkSpeakerTwo}
                fluidSpeakerThree={event.speakerThree.childImageSharp.fluid}
                nameSpeakerThree={event.nameSpeakerThree}
                jobSpeakerThree={event.jobSpeakerThree}
                companySpeakerThree={event.companySpeakerThree}
                linkSpeakerThree={event.linkedinLinkSpeakerThree}
                fluidSpeakerFour={event.speakerFour.childImageSharp.fluid}
                nameSpeakerFour={event.nameSpeakerFour}
                jobSpeakerFour={event.jobSpeakerFour}
                companySpeakerFour={event.companySpeakerFour}
                linkSpeakerFour={event.linkedinLinkSpeakerFour}
                fluidSpeakerFive={event.speakerFive.childImageSharp.fluid}
                nameSpeakerFive={event.nameSpeakerFive}
                jobSpeakerFive={event.jobSpeakerFive}
                companySpeakerFive={event.companySpeakerFive}
                linkSpeakerFive={event.linkedinLinkSpeakerFive}
                fluidSpeakerSix={event.speakerSix.childImageSharp.fluid}
                nameSpeakerSix={event.nameSpeakerSix}
                jobSpeakerSix={event.jobSpeakerSix}
                companySpeakerSix={event.companySpeakerSix}
                linkSpeakerSix={event.linkedinLinkSpeakerSix}
                colorSpeaker={colorSpeaker}
                titleModerator={titleModerator}
                colorTextSpeaker={event.colorTextSpeaker}
                speakerTitle={event.speakerTitle}
                paddingSpeaker={event.paddingSpeaker}
              ></SpeakerRowThreeTwo>
            )}
            {event.titleSection && (
              <OtherSection
                titleSection={event.titleSection}
                contentSection={event.contentSection}
                colorSection={event.colorSection}
                contentSectionTwo={event.contentSectionTwo}
                nameSpeakerOne={event.nameSpeakerOne}
                nameSpeakerTwo={event.nameSpeakerTwo}
                fluidSpeakerOne={event.speakerOne.childImageSharp.fluid}
                fluidSpeakerTwo={event.speakerTwo.childImageSharp.fluid}
                jobSpeakerOne={event.jobSpeakerOne}
                jobSpeakerTwo={event.jobSpeakerTwo}
                imgOne={event.imgSectionOne.childImageSharp.fluid}
                imgTwo={event.imgSectionTwo.childImageSharp.fluid}
              ></OtherSection>
            )}
            {event.altLogoClever && (
              <>
                <LogoSection
                  logoClever={event.logoClever.childImageSharp.fluid}
                  support={event.support}
                  logoCompanyOne={event.logoCompanyOne.childImageSharp.fluid}
                  altCompanyOne={event.altCompanyOne}
                  disclaimer={event.disclaimer}
                ></LogoSection>
              </>
            )}
            {/*   MUESTRA IMPUT DE INSCRIPCION */}
            {showInput === "showInscription" && (
              <>
                <ShowInscription
                  linkVideo={event.video}
                  idMail={event.id}
                  templateId={event.templateId}
                  text={event.text}
                  colorInput={event.colorInput}
                  disclaimer={event.disclaimer}
                  btnInputColor={event.btnInputColor}
                  btnBorder={event.btnBorder}
                  btnBorderRadius={event.btnBorderRadius}
                  btnInputColorDown={event.btnInputColorDown}
                  btnInputColorText={event.btnInputColorText}
                ></ShowInscription>

                {/*  <section
                  id="section-donate"
                  style={{
                    backgroundColor: colorInput,
                    paddingBottom: "15rem",
                    paddingTop: "5rem",
                  }}
                >
                  <Row style={{ justifyContent: "center" }}>
                    <Title>
                      {!submitted &&
                        Parser(
                          " Inscríbete <br> <small>a este gran evento </small> "
                        )}

                      {submitted &&
                        Parser(
                          "Muchas gracias, dentro de poco te enviaremos la invitación <br> 🥰🤓🥳"
                        )}
                    </Title>
                  </Row>
                  {!submitted && (
                    <Row style={{ justifyContent: "center" }}>
                      <form
                        style={{
                          justifyContent: "center",
                          width: "100%",
                          textAlign: "center",
                        }}
                        onSubmit={e => {
                          e.preventDefault()
                          setDisabledButton(true)
                          handleSuccess()
                        }}
                      >
                        <ImputMail
                          placeholder="correo electrónico"
                          onChange={e => {
                            setEmail(e.target.value)
                            setSubmitted(false)
                          }}
                          required
                          value={email}
                          type="email"
                        />

                        <BtnSend disabled={disabledButton}>
                          {loading ? (
                            "Enviar"
                          ) : (
                            <img
                              src={Spinner}
                              alt="loading"
                              style={{
                                width: "22px",
                              }}
                            ></img>
                          )}
                        </BtnSend>
                      </form>
                    </Row>
                  )}
                </section> */}
              </>
            )}
            {/* AQUI MUESTRA EL IMPUT PARA VER VIDEO */}

            {showInput === "showwebinar" && (
              <>
                <section
                  id="section-inscription"
                  style={{
                    backgroundColor: colorInput,
                    paddingBottom: "15rem",
                    paddingTop: "5rem",
                  }}
                >
                  <Row style={{ justifyContent: "center" }}>
                    <Title>
                      {!toVideo && Parser(" ¿Deseas ver nuestro webinar? ")}

                      {toVideo &&
                        Parser("Muchas gracias, disfruta de nuestro webinar")}

                      {/* {loading &&
                      (toVideo
                        ? "Muchas gracias, ahora disfruta de nuestro webinar"
                        : "¿Deseas ver nuestro webinar?")} */}
                    </Title>
                  </Row>
                  {!toVideo && (
                    <Row style={{ justifyContent: "center" }}>
                      <form
                        style={{
                          justifyContent: "center",
                          width: "100%",
                          textAlign: "center",
                        }}
                        onSubmit={e => {
                          e.preventDefault()
                          setDisabledButton(true)
                          setToVideo(true)
                        }}
                      >
                        <ImputMail
                          placeholder="correo electrónico"
                          onChange={e => {
                            setEmail(e.target.value)
                            setSubmitted(false)
                          }}
                          required
                          value={email}
                          type="email"
                        />

                        <BtnSend disabled={disabledButton}>
                          {loading ? (
                            "Enviar"
                          ) : (
                            <img
                              src={Spinner}
                              alt="loading"
                              style={{
                                width: "100%",
                                height: "auto",
                                maxWidth: "22px",
                                marginRight: "auto",
                                marginLeft: "auto",
                              }}
                            ></img>
                          )}
                        </BtnSend>
                      </form>
                    </Row>
                  )}

                  {toVideo && (
                    <Row>
                      <DivVideo>
                        <iframe
                          title="video webinar"
                          className="responsive-iframe"
                          width="1280"
                          height="720"
                          frameborder="0"
                          src={event.video}
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          style={{ border: "none" }}
                          allowfullscreen="allowfullscreen"
                          mozallowfullscreen="mozallowfullscreen"
                          msallowfullscreen="msallowfullscreen"
                          oallowfullscreen="oallowfullscreen"
                          webkitallowfullscreen="webkitallowfullscreen"
                        ></iframe>
                      </DivVideo>
                    </Row>
                  )}
                </section>
              </>
            )}
            {/*   MUESTRA IMPUT DE DONACION */}
            {showInput === "showdonate" && (
              <ShowDonate
                toVideo={toVideo}
                email={email}
                submitted={submitted}
                disabledButton={disabledButton}
                loading={loading}
                handleSuccess={handleSuccess}
                linkVideo={event.video}
                id={id}
                templateId={templateId}
                text={text}
              ></ShowDonate>
            )}
          </EventContainer>
        </Layout>
      </div>
    </>
  )
}
export default EventPage

const Title = styled.h2`
  font-family: "Inter", sans-serif;
  font-weight: bold;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  /* margin-top: 2rem; */

  @media (max-width: 900px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`

const SubTitle = styled.h4`
  font-family: "Inter", sans-serif;
  text-align: center;
  margin-bottom: 4rem;
  padding-left: 5rem;
  padding-right: 5rem;

  @media (max-width: 900px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  @media (max-width: 600px) {
    font-size: 1.3rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

const DivLogo = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 3rem;
  padding-left: 2rem;
  padding-right: 2rem;
  img {
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
    border: 0;
    height: auto;
    object-fit: scale-down !important;
  }
`
const RowImg = styled.div`
  justify-content: center;
  text-align: center;
  width: 100%;
  img {
    object-fit: scale-down !important;
  }
`
const ImputMail = styled.input`
  padding: 1rem 4rem 1rem 1rem;
  margin-right: 2rem;
  border-radius: 6px;
  border-width: 0;
  @media (max-width: 502px) {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1rem 5rem 1rem 1rem;
  }
  @media (max-width: 339px) {
    padding: 1rem 3rem 1rem 1rem;
  }
`
const BtnSend = styled.button`
  background-color: #efefef !important;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 6px;
  border-width: 0;
  :active {
    background-color: #efefef !important;
  }
  :hover {
    background-color: #efefef !important;
  }
  :visited {
    background-color: #efefef !important;
  }
  :link {
    background-color: #efefef !important;
  }
`

const EventContainer = styled.div`
  margin: 0 auto !important;

  /* padding-bottom: 20rem !important; */
  text-align: justify;
  justify-content: center;
  padding-top: 25vh;

  h1 {
    font-family: "Inter", sans-serif;
    text-align: left;
    padding-bottom: 20px;
    font-weight: bold;
  }
  h3 {
    font-family: "Inter", sans-serif;
    font-weight: bold;
  }
  li {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  ol {
    margin-top: 5rem;
    margin-bottom: 5rem;
    padding-inline-start: 20px;
  }
  ul {
    padding-inline-start: 20px;
  }

  a {
    word-wrap: break-word;
    font-size: 1rem;
  }
  img {
    object-fit: scale-down !important;
  }

  @media (min-width: 601px) {
    width: 90%;
  }

  @media (min-width: 993px) {
    width: 50%;
  }
`
const DivVideo = styled.div`
  text-align: center;
  max-width: 1536px;
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  margin-right: auto;
  margin-left: auto;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`
